"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/popover/style/css");

var _popover = _interopRequireDefault(require("antd/es/popover"));

var _react = _interopRequireWildcard(require("react"));

require("./newQnaPostForm.scss");

var _icons = require("@ant-design/icons");

var _FlagResolveMenu = _interopRequireDefault(require("./FlagResolveMenu"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

class FlagActionItem extends _react.Component {
  render() {
    const {
      participantId,
      id,
      isHidden,
      type,
      flags,
      style,
      innerStyle
    } = this.props;
    const unresolvedFlags = flags ? flags.filter(f => f.resolveDate === null && f.resolution === null) : [];
    return unresolvedFlags.length > 0 || isHidden ? /*#__PURE__*/_react.default.createElement(_popover.default, {
      key: `popover-flag-action-item-${type}-${id}`,
      content: /*#__PURE__*/_react.default.createElement(_FlagResolveMenu.default, {
        participantId: participantId,
        id: id,
        isHidden: isHidden,
        type: type
      }),
      title: "Resolve Flag",
      trigger: "click",
      style: style
    }, /*#__PURE__*/_react.default.createElement("a", {
      style: innerStyle,
      className: "hmp-flag-icon-wrapper red-flag"
    }, /*#__PURE__*/_react.default.createElement("span", {
      key: "list-vertical-flag-o"
    }, /*#__PURE__*/_react.default.createElement(_icons.FlagOutlined, {
      style: {
        marginRight: 8
      }
    }), unresolvedFlags.length))) : /*#__PURE__*/_react.default.createElement(FlagOutlinedIconText, {
      text: unresolvedFlags.length,
      key: "list-vertical-flag-o"
    });
  }

}

var _default = FlagActionItem;
exports.default = _default;